import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

export default class ClipboardTextField extends Component {
  static propTypes = {
    text: PropTypes.string.isRequired,
    elementName: PropTypes.string.isRequired,
    copyConfirmationMessage: PropTypes.string,
    textArea: PropTypes.bool,
  }

  static defaultProps = {
    copyConfirmationMessage: 'Copied to clipboard!',
    textArea: false,
  }

  handleCopyClick = (event) => {
    // Select the text field contents, and copy them to the clipboard
    $(`#${this.props.elementName}`).select();
    document.execCommand('copy');

    // Show a confirmation message, saying we copied to the clipboard
    $(`#${this.props.elementName}_confirmation`).show();
  }

  handleTextClick = (event) => {
    event.target.focus();
    event.target.select();
  }

  renderInput() {
    const inputProperties = {
      id: this.props.elementName,
      value: this.props.text,
      className: 'u-mb-0',
      readOnly: true,
      onClick: this.handleTextClick,
    };

    if (this.props.textArea) {
      return <textarea {...inputProperties} />;
    }

    return <input type="text" {...inputProperties} />;
  }

  render() {
    return (
      <div>
        <div className="u-flex u-mb-4 u-items-stretch">
          <div className="u-flex-1 u-pr-2">
            {this.renderInput()}
          </div>
          <div className="u-px-2 Button u-w-13 u-flex u-items-center u-justify-center" onClick={this.handleCopyClick}>
            <i className="Icon Icon-clipboard u-cursor-pointer u-mr-0" />
          </div>
        </div>
        <div
          id={`${this.props.elementName}_confirmation`}
          className="u-hidden u--mt-2 u-mb-4 u-text-old-even-darker-grey u-text-sm"
        >
          {this.props.copyConfirmationMessage}
        </div>
      </div>
    );
  }
}
